// ─── Date helpers ─────────────────────────────────────────────────────────────

export function dateToStr(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${dd}`;
}
export function todayStr() { return dateToStr(new Date()); }
export function addDays(dateStr, n) {
  const d = new Date(dateStr + 'T00:00:00');
  d.setDate(d.getDate() + n);
  return dateToStr(d);
}
export function weekStartOf(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  const dow = d.getDay();
  d.setDate(d.getDate() + (dow === 0 ? -6 : 1 - dow));
  return dateToStr(d);
}
export function formatWeekLabel(ws) {
  return new Date(ws + 'T00:00:00').toLocaleDateString('en-GB', {
    day: 'numeric', month: 'long', year: 'numeric',
  });
}
export function shortDayLabel(dateStr) {
  const d = new Date(dateStr + 'T00:00:00');
  return `${d.toLocaleDateString('en-GB', { weekday: 'short' })} ${d.getDate()} ${d.toLocaleDateString('en-GB', { month: 'short' })}`;
}
export function longDayLabel(dateStr) {
  return new Date(dateStr + 'T00:00:00').toLocaleDateString('en-GB', {
    weekday: 'long', day: 'numeric', month: 'long', year: 'numeric',
  });
}

// ─── Entry filtering / sorting ────────────────────────────────────────────────

export function applyFlkFilter(entries, filter) {
  if (!filter || filter === 'all') return entries;
  return entries.filter(e => (e.module || '').toUpperCase().includes(filter));
}
export function applySortEntries(entries, sort) {
  if (!sort || sort === 'priority') return entries;
  const s = [...entries];
  if (sort === 'subject') s.sort((a, b) => (a.subject_area || '').localeCompare(b.subject_area || ''));
  else if (sort === 'lightest') s.sort((a, b) => (a.principle_count || 0) - (b.principle_count || 0));
  else if (sort === 'heaviest') s.sort((a, b) => (b.principle_count || 0) - (a.principle_count || 0));
  return s;
}
